var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2303 11.0784C20.2019 10.9582 20.1443 10.8469 20.0625 10.7543C19.9807 10.6618 19.8773 10.5908 19.7616 10.5478L14.3606 8.52187L15.735 1.64718C15.7661 1.48745 15.7444 1.32194 15.6732 1.1756C15.602 1.02927 15.4852 0.910072 15.3403 0.835986C15.1954 0.761899 15.0303 0.736949 14.87 0.7649C14.7097 0.792851 14.5628 0.872186 14.4516 0.990934L3.95156 12.2409C3.86628 12.3308 3.80459 12.4404 3.772 12.5599C3.7394 12.6794 3.73692 12.8052 3.76478 12.9259C3.79264 13.0466 3.84996 13.1585 3.93163 13.2517C4.01331 13.3448 4.11678 13.4163 4.23281 13.4597L9.63562 15.4856L8.265 22.3528C8.23388 22.5125 8.25555 22.6781 8.32676 22.8244C8.39796 22.9707 8.51482 23.0899 8.65971 23.164C8.8046 23.2381 8.96966 23.263 9.12998 23.2351C9.29029 23.2071 9.43717 23.1278 9.54844 23.0091L20.0484 11.7591C20.1322 11.6692 20.1926 11.5601 20.2243 11.4414C20.256 11.3228 20.2581 11.1981 20.2303 11.0784ZM10.2534 20.0625L11.235 15.1519C11.2701 14.9777 11.2423 14.7967 11.1564 14.6412C11.0706 14.4856 10.9323 14.3656 10.7662 14.3025L5.8125 12.4416L13.7456 3.94218L12.765 8.85281C12.7299 9.02697 12.7577 9.20794 12.8436 9.36349C12.9294 9.51904 13.0677 9.63907 13.2338 9.70218L18.1838 11.5584L10.2534 20.0625Z",
    fill: "#AFAFAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/Power.8afd8ca81dbaa22a42fbc999c27828a7.svg";
export { ForwardRef as ReactComponent };